<template>
  <v-container fluid class="login fill-height align-content-center bg-clouds pa-0 ma-0">
    <v-col cols="12" md="8" class="mx-auto text-center my-12">
      <h1 class="display-2">
        {{ $wm.title }}
      </h1>
    </v-col>

    <v-col cols="12" md="8" class="mx-auto">
      <v-card elevation="0" color="grey lighten-5">
        <v-col cols="12">
          <v-card-title>
            <h2>
              {{
                  loginForm
                    ? $t("login.connection.title")
                    : $t("login.register.title")
              }}
            </h2>
          </v-card-title>
          <v-card-text>
            <template v-if="$route.query.free_test">
              <v-alert colored-border color="success" border="top">
                {{ $t('login.register.free_test') }}
              </v-alert>
            </template>
            <template>
              <v-form ref="registerFormRef" @submit.prevent="register" lazy-validation>
                <v-text-field filled id="register-last-name" label="Nom" type="text" name="nom" v-model="user.user_nom"
                  :rules="[(v) => !!v || $t('login.register.lastnameError')]" required />
                <v-text-field filled :label="$t('login.register.firstname')" type="text" name="firstnameRegister"
                  v-model="user.user_prenom" :rules="[(v) => !!v || $t('login.register.firstnameError')]" required />
                <v-text-field filled :label="$t('login.register.email')" v-model="user.user_email" type="email"
                  name="emailRegister" :rules="[
                    (v) => !!v || $t('login.register.emailError'),
                    (v) =>
                      /.+@.+\..+/.test(v) || $t('login.register.emailInvalid'),
                  ]" required />
                <v-text-field filled :label="$t('login.register.password')" type="password" name="passwordRegister"
                  v-model="user.user_password" :rules="[(v) => !!v || $t('login.register.passwordError')]" required />
                <v-text-field filled :label="$t('login.register.passwordConfirm')" type="password"
                  name="confirmPasswordRegister" v-model="user.passordConfirm" :rules="[
                    (v) =>
                      v === user.user_password ||
                      $t('login.register.passwordError'),
                  ]" required />
                <v-btn elevation="0" block color="primary" type="submit" :loading="registerLoading">{{
                    $t("login.register.title")
                }}</v-btn>
                <hr class="my-6" />
                <v-btn :loading="loading" elevation="0" block color="info" type="button" to="/login">J'ai déjà un compte
                </v-btn>
              </v-form>
            </template>
          </v-card-text>
        </v-col>
      </v-card>
    </v-col>

    <v-snackbar top block v-model="success" color="success">{{
        $t("login.snackbarSuccess")
    }}</v-snackbar>
    <v-snackbar top block v-model="error" color="error">{{
        $t("login.snackbarError")
    }}</v-snackbar>
  </v-container>
</template>

<script>
import api from "@/api";
export default {
  data: () => ({
    // Form data
    user: {
      user_nom: null,
      user_prenom: null,
      user_email: null,
      user_password: null,
    },
    phoneValid: null,
    // Form settings
    loginForm: true,
    // Error snackbar
    success: false,
    error: false,
    loading: false,
    loginLoading: false,
    registerLoading: false,
  }),
  methods: {
    // Lazy validation on phone input
    phoneValidation(formattedNumber, { number, valid }) {
      this.user.user_phone = number.international;
      this.phoneValid = valid;
    },
    // Log in user
    async login() {
      this.loginLoading = true;
      this.loading = true;
      try {
        let login = await api.login(
          this.user.user_email,
          this.user.user_password
        );

        // Store token & user informations
        this.$store.dispatch("setToken", login.token);
        let user = await api.users.get(login.user.id_user);
        this.$store.dispatch("setUser", user);

        this.$router.push("/");
      } catch (err) {
        console.error(err);
        this.error = true;
      }
      this.loading = false;
      this.loginLoading = false;
    },
    // register new user
    async register() {
      this.registerLoading = true;
      if (this.$refs.registerFormRef.validate()) {
        try {
          if (this.$route.query.referrer) {
            this.user.referrer = this.$route.query.referrer;
          }
          let response_register = await api.registerUser(this.user);
          if (this.$route.query.free_test) {
            await api.registerFreeTest(response_register.insertId);
          }

          this.success = true;
          this.$router.push("/login");
        } catch (err) {
          console.error(err);
          this.error = true;
        }
      }
      this.registerLoading = false;
    },
  },
  mounted() {
    if (this.$route.query.register) {
      this.loginForm = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.v-application {
  background: url("/img/clouds.jpg") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: scroll !important;
}
</style>